import React, {createRef} from 'react';

import "./textfield.css"

const TextfieldAbattement = (props) => {


    return (
        <input type={props.type} 
        className={"input_abattement"} 
        readOnly
        placeholder={props.placeholder}
        />

    );
};

export default TextfieldAbattement;
